var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.4171,
    height: 41.4171,
    rx: 20.7086,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0801 22.8657L20.3999 27.0257C20.5131 27.0823 20.5697 27.1106 20.6291 27.1217C20.6817 27.1316 20.7356 27.1316 20.7882 27.1217C20.8476 27.1106 20.9042 27.0823 21.0173 27.0257L29.3372 22.8657M12.0801 18.5514L20.3999 14.3915C20.5131 14.3349 20.5697 14.3066 20.6291 14.2955C20.6817 14.2856 20.7356 14.2856 20.7882 14.2955C20.8476 14.3066 20.9042 14.3349 21.0173 14.3915L29.3372 18.5514L21.0173 22.7114C20.9042 22.768 20.8476 22.7963 20.7882 22.8074C20.7356 22.8173 20.6817 22.8173 20.6291 22.8074C20.5697 22.7963 20.5131 22.768 20.3999 22.7114L12.0801 18.5514Z",
    stroke: "#080808",
    strokeWidth: 1.72571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan2);
export default __webpack_public_path__ + "static/media/plan2.92c0eb610c668a797a3147d12ab6090e.svg";
export { ForwardRef as ReactComponent };